import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export class IncentiveTag extends HasProjectMixin(Model) {
  static get $name() {
    return "IncentiveTag";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "value" },
      { name: "description", dataSource: "description" },
      { name: "categoryId", dataSource: "category" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }

  get categoryRecord() {
    if (this.project) {
      return this.project.getCrudStore(STORE_KEYS.incentiveTagCategoryStore).getById(this.categoryId);
    }
    return null;
  }

}
